<agm-map #map class="results-map__map" [zoomControl]="true" [streetViewControl]="false" [mapDraggable]="true"
         [scrollwheel]="true" gestureHandling="greedy" [mapTypeControl]="true"
         [mapTypeControlOptions]="mapTypeControlOptions" (boundsChange)="onBoundsChange($event)">
  <ng-container *ngIf="showAirports">
  <agm-marker #airportMarker
              *ngFor="let airport of airports"
              [iconUrl]=this.getAirportIconUrl(airport)
              [label]="airport.minPrice !== null ? '$' + airport.minPrice.toFixed(2) : null"
              [latitude]="airport.location.lat"
              [longitude]="airport.location.lon"
              [opacity]=".8"
              (markerClick)="onAirportMarkerClick(airport)"
              (mouseOver)="onAirportMarkerHover(airport, true)"
              (mouseOut)="onAirportMarkerHover(airport, false)"
              [matTooltip]="airport.identifier">
    <agm-snazzy-info-window #airportInfoWindow
                            [maxWidth]="380"
                            [maxHeight]="200"
                            [padding]="0"
                            [fontSize]="11"
                            [shadow]="false"
                            [pointer]="true"
                            [closeWhenOthersOpen]="true"
                            [closeOnMapClick]="true"
                            [showCloseButton]="false"
                            [isOpen]="airport === selectedAirport"
                            (afterClose)="onCloseAirportCardWindow()">
      <ng-template>
        <app-airport-summary-card [airport]="airport" [interactive]="true" [compact]="true"></app-airport-summary-card>
      </ng-template>
    </agm-snazzy-info-window>
  </agm-marker>
  </ng-container>

  <agm-marker #activityMarker
              *ngFor="let activity of activities"
              [iconUrl]="getIconUrl(activity)"
              [latitude]="activity.geometry.location.lat()"
              [longitude]="activity.geometry.location.lng()"
              (markerClick)="onActivityMarkerClick(activity)"
              (mouseOver)="onActivityMarkerHover(activity, true)"
              (mouseOut)="onActivityMarkerHover(activity, false)">
    <agm-snazzy-info-window #activityInfoWindow
                            [maxWidth]="420"
                            [padding]="2"
                            [fontSize]="11"
                            [shadow]="false"
                            [pointer]="true"
                            [closeWhenOthersOpen]="true"
                            [closeOnMapClick]="true"
                            [showCloseButton]="false"
                            [isOpen]="activity === selectedActivity"
                            (afterClose)="onCloseActivityWindow(activity)">
      <ng-template>
        <app-places-info-window [activity]="activity"></app-places-info-window>
      </ng-template>
    </agm-snazzy-info-window>
  </agm-marker>
  <agm-marker #aviationEventMarker
              *ngFor="let aviationEvent of aviationEvents"
              [iconUrl]=this.getAviationEventIconUrl(aviationEvent)
              [latitude]="aviationEvent.location.lat"
              [longitude]="aviationEvent.location.lon"
              [opacity]=".8"
              [zIndex]=this.getEventIconZIndex(aviationEvent)
              (markerClick)="onAviationEventMarkerClick(aviationEvent)"
              (mouseOver)="onAviationEventMarkerHover(aviationEvent, true)"
              (mouseOut)="onAviationEventMarkerHover(aviationEvent, false)"
              [matTooltip]="aviationEvent.eventId.toString()">
    <agm-snazzy-info-window #aviationEventInfoWindow
                            [maxWidth]="380"
                            [maxHeight]="200"
                            [padding]="0"
                            [fontSize]="11"
                            [shadow]="false"
                            [pointer]="true"
                            [closeWhenOthersOpen]="true"
                            [closeOnMapClick]="true"
                            [showCloseButton]="false"
                            [isOpen]="aviationEvent === selectedAviationEvent"
                            (afterClose)="onCloseAviationEventCardWindow()">
      <ng-template>
        <app-event-summary-card [aviationEvent]="aviationEvent" [interactive]="true" [compact]="true"></app-event-summary-card>
      </ng-template>
    </agm-snazzy-info-window>
  </agm-marker>
  <agm-info-window #airportInfoTooltip [disableAutoPan]="true">
    <div *ngIf="activeAirport" class="results-map__airport-tooltip">
      {{ identifier }} {{ activeAirport.name }}
    </div>
  </agm-info-window>
  <agm-info-window #aviationEventInfoTooltip [disableAutoPan]="true">
    <div *ngIf="activeAviationEvent" class="results-map__airport-tooltip">
      {{ activeAviationEvent.title }}
    </div>
  </agm-info-window>
</agm-map>
<div *ngIf="message" class="results-map__msg-wrapper">
  <div class="results-map__msg">{{ message }}</div>
</div>
<div *ngIf="onEventsTab" class="results-map__msg-top-wrapper">
  <div class="results-map__top-msg">{{ eventDatesMessage }}</div>
</div>
